<template>
  <div style="margin-top:-10px !important">
      <RecordNotFound v-if="status_code==404" :message="status_message"></RecordNotFound>
  <div v-else>
    <GlobalHeader title="Filter Form" @redirectPage="redirectPage"></GlobalHeader>
    <!-- validation -->
    <b-form @submit.prevent="Search" id="group_form" style="margin-left:3px;margin-right:3px;">
      <b-row class="mt-2 px-pad">
        <b-col xl="12" lg="12" md="12" xs="12" sm="12" class="px-0">
          <div class="container-fluid">
            <!-- <b-alert :show="code == 201" class="alert-transparent alert-danger">
              <p class="fw-semi-bold">Filter with this name already exists!</p>
            </b-alert>-->
            <b-alert
              class="alert-transparent alert-danger"
              :show="error_show && errors.items.length > 0"
            >
              <button type="button" @click="error_show = !error_show" class="close">
                <span aria-hidden="true">&times;</span>
              </button>
              <div v-for="(item,index) in errors.items" :key="index">
                <p class="fw-semi-bold">{{ item.msg }}</p>
              </div>
            </b-alert>
          </div>
        </b-col>
      </b-row>
      <div class="sales-bg pt-30p pb-4 mb-2 border-bottom-dot" style="background:#f7f7f7">
        <b-row style="max-width:1000px;">
          <b-col xl="7" lg="8" md="8" sm="8" xs="8">
            <b-form-input
              v-validate="'required|max:50'"
              v-model.trim="filter_name"
              type="text"
              size="sm"
              placeholder="Filter name"
              name="filter_name"
              data-vv-name="Custom filter name"
            />
          </b-col>
          <b-col lg="6" class="text-right"></b-col>
        </b-row>
      </div>

      <b-row style="max-width:1000px;" class="mt-4">
        <b-col xl="7" lg="8" md="8" sm="8" xs="8">
          <label for="filter_desc">Description</label>
          <b-form-textarea
            v-validate="'max:255'"
            v-model.trim="filter_desc"
            name="filter_desc"
            data-vv-name="filter description"
            :rows="4"
            id="internal_notes"
            placeholder="Descriptions"
          />
          <span class="text-danger" v-if="errors.has('filter_desc')">Not exceeds 255 characters</span>
        </b-col>
        <b-col lg="6" class="text-right"></b-col>
      </b-row>

      <br />
      <h5 class="mb-3 mt-4">Create Filter</h5>
      <div style="max-width:1200px;">
        <FilterForm
          v-if="custom != null && ((this.$route.name == 'FilterUpdate' && filter_pattern != '') || (this.$route.name == 'FilterCreate'))"
          :items="items"
          :filter_pattern="filter_pattern"
          :custom="custom"
          page="filter"
          :settings="{}"
          v-on:submit="submit"
        />
      </div>
      <br />
      <b-row class="pb-4">
        <b-col xl="4" lg="6" md="6" sm="6" xs="6">
          <b-form-radio-group
            class="mt-1"
            id="filter_status"
            v-model="filter_for_all"
            :options="filter_for_all_crieteria"
          />
        </b-col>
      </b-row>
      <div class="footer">
        <div :class="{'form-action' : true, 'text-left' : true}">
          <b-button type="submit" variant="primary" class="btn-rounded mr-3" :disabled="submitted">
            <i v-if="submitted" class="fa fa-circle-o-notch fa-spin mr-2"></i>
            {{ !$route.params.id ? 'Save' : 'Update' }}
          </b-button>
          <b-button
            v-if="$route.params.id"
            v-b-modal.filterdelete
            type="button"
            variant="default"
            class="btn-rounded mr-3"
          >Delete</b-button>
        </div>
      </div>
    </b-form>
    <b-modal
      id="filterdelete"
      size="sm"
      body-class="bg-white"
      cancel-title="Cancel"
      cancel-variant="light"
      :ok-title-html="modalsubmit==true?loaderIcon+'Yes':'Yes'"
      :ok-disabled="modalsubmit"
      title="Delete Filter"
      @ok="handlefilterdelete"
    >
      <p>Are you sure you want to deleting this filter ?</p>
    </b-modal>
  </div>
  </div>
</template>
<script>
import store from "@/store/index";
import $ from "jquery"; // for using jquery function
import FilterForm from "@/components/Form/FilterForm";
import { EventBus } from "@/event-bus.js"; // call bus event to access child component method from parent component
import { mapState } from "vuex";
import RecordNotFound from "@/pages/Error/RecordNotFound";
export default {
  props: ["module", "submitted", "code"],
  components: {
    FilterForm,
    RecordNotFound
  },
  data() {
    return {
      filter_for_all_crieteria: [
        // radio button for taxable preferance
        {
          text: "For all",
          value: "1"
        },
        {
          text: "Only Me",
          value: "0"
        }
      ],
      loaderIcon: `<i class="fa fa-circle-o-notch fa-spin mr-2"></i>`,
      modalsubmit: false,
      custom: {},
      settings: "",
      error_show: false,
      filter_desc: "",
      filter_name: "",
      filter_for_all: "1",
      filter_pattern: "",
      status_id: "",
      items: this.createFreshObject()
    };
  },
  async created() {
    await this.callcustomfields();
  },
  watch: {
    module: function(newVal, oldVal) {
      if (newVal != oldVal) {
        this.callcustomfields();
      }
    }
  },
  methods: {
    redirectPage() {
      if (this.$route.params.path != "Index") {
        this.$router.push({
          name: this.$route.params.path,
          query: this.status_id
            ? {
                status: this.status_id
              }
            : ""
        });
      }
      this.$router.push({
        name:
          store.state.general.allfilter_details[this.$route.params.route].path,
        query: this.status_id
          ? {
              status: this.status_id
            }
          : ""
      });
    },
    handlefilterdelete() {
      this.submit = true;
      var data = JSON.stringify({
        id: this.$route.params.id
      });
      this.$store
        .dispatch(this.custom.module + "/filterdelete", data)
        .then(() => {
          this.submit = false;
          window.Messenger().post({
            extraClasses:
              "messenger-fixed messenger-on-top messenger-on-center",
            message: this.$store.state[this.custom.module].status_message,
            type: this.$store.state[this.custom.module].status_type,
            showCloseButton: true
          });
          this.$route.params.route!='quotation' ?store.state[this.$route.params.route].index_status="":store.state[this.$route.params.module].index_status=""
          this.$router.push({
            name:
              this.$route.params.path != "Index"
                ? this.$route.params.path
                : this.$route.params.route!='quotation'?store.state.general.allfilter_details[
                    this.$route.params.route
                  ].path:store.state.general.allfilter_details[
                    this.$route.params.module
                  ].path
          });
        });
    },
    createFreshObject() {
      return [
        {
          generatemessage: "Type to search",
          autoselect: "",
          arrayvalues: [],
          options: [],
          filter_matching: "When",
          columns: "",
          cat: "",
          field: "",
          comparator: "",
          value: "",
          type: "text"
        }
      ];
    },
    updateFields() {
      this.$store
        .dispatch(
          "settings/fetchfilterList",
          JSON.stringify({
            id: this.$route.params.id,
            stg_menu:
              this.module ||
              store.state.general.allfilter_details[this.$route.params.route]
                .title
          })
        )
        .then(res => {
          this.filter_name = res.filter_hdr.filter_name;
          this.status_id = res.filter_hdr.status_id || "";
          this.filter_desc = res.filter_hdr.filter_notes;
          this.filter_pattern = res.filter_hdr.filter_pattern;
          this.filter_for_all = res.filter_hdr.filter_for_all;
          this.items = res.filter_itm;
        });
    },
    async callcustomfields() {
      await this.$store
        .dispatch(
          "settings/filterdetails",
          JSON.stringify({
            stg_menu:
              this.module ||
              store.state.general.allfilter_details[this.$route.params.route]
                .title
          })
        )
        .then(async result => {
          this.settings = result.custom ? result.custom.settings : {};
          if (this.$route.name == "FilterUpdate") {
            await this.updateFields();
          } else {
            this.items = await this.createFreshObject();
          }

          this.custom = await result.custom;
        if(this.status_code==404){
        store.state[this.$route.params.route].index_status=""
          }
        });
    },
    submit(ev) {
      if (ev.result == false) {
        // Scroll to error message show
        var content = $(".container-fluid");
        content[0].scrollIntoView(false);
        this.error_show = true;
      }
      if (ev.result == true) {
        var data = JSON.stringify({
          filter_name: this.filter_name,
          filter_desc: this.filter_desc,
          filter_pattern: ev.pattern,
          pattern_array: ev.pattern_array,
          filter_for_all: this.filter_for_all,
          items: this.items
        });
        this.$emit("filterform", {
          id: this.$route.params.id || "",
          module: this.custom.module,
          name:
            this.module ||
            store.state.general.allfilter_details[this.$route.params.route]
              .title,
          items: data
        });
      }
    },

    //search
    Search() {
      EventBus.$emit("validatefilter");
    }
  },
   computed: {
    ...mapState({
      status_code: state => state.settings.status_code,
      status_message: state => state.settings.status_message,
      status_type: state => state.settings.status_type
    })
  }
};
</script>
<style scoped>
.navbar .form-control {
  line-height: 13px !important;
  padding-top: 7px !important;
  padding-bottom: 1px !important;
}
</style>
<style >
.adv_del {
  padding-top: 6px;
}
</style>